/* eslint-disable prettier/prettier */

import { useState } from "react";
// import {Button} from 'antd';
import DokanIcons from "../icon/DokanIcons";

export default function ScrollButton() {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
      /* you can also use 'auto' behaviour
               in place of 'smooth' */
    });
  };

  window.addEventListener("scroll", toggleVisible);

  return (
    <>
      <div className="m-25px fixed bottom-0 right-0" style={{ display: visible ? "flex" : "none" }}>
        <button type="button" onClick={scrollToTop} className="bg-blue-dodger p-3 rounded-md">
          <DokanIcons icon="#arrowUp"/>
        </button>
      </div>
    </>
  );
}
